<template>
    <div>
        <h2>配置本资源</h2>
        <el-form :model="searchData" label-width="82px">
            <el-col :span="4">
                <el-form-item label="院校类型">
                    <el-select v-model="searchData.yxTpye" placeholder="请选择院校类型" clearable  @change='chooseYX'>
                        <el-option
                            v-for="item in CollegesType"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="选择专业">
                    <el-select v-model="searchData.zyName" placeholder="请选择专业名称" clearable @change='chooseZY'>
                        <el-option
                            v-for="item in zyData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="选择课程">
                    <el-select v-model="searchData.kcName" placeholder="请选择选择课程" clearable @change='chooseKC'>
                        <el-option
                            v-for="item in kcData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="章">
                    <el-select v-model="searchData.zName" placeholder="请选择章" clearable @change='chooseZ'>
                        <el-option
                            v-for="item in zData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="节">
                    <el-select v-model="searchData.jName" placeholder="请选择节" clearable @change='chooseJ'>
                        <el-option
                            v-for="item in jData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span='24'>
                <el-form-item label="选择知识点" class="a r">
                    <div class="chooseZY">
                        <el-checkbox-group v-model="searchData.zsdName" @change="changeZsd" style="display:flex;flex-wrap:wrap">
                            <el-checkbox v-for="item in zsdData" :label="item.node_id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                        <div v-if="selectList.length>0">
                            <p>当前资源知识点：</p>
                               <el-checkbox-group v-model="searchData.zsdName" @change="changeZsd" style="display:flex;flex-wrap:wrap">
                            <el-checkbox v-for="item in selectList" :label="item.node_id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                        </div>
                    </div>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
                <div class="button">
                    <el-button @click="clearData">清空</el-button>
                    <el-button type="primary" @click="submit">提交</el-button>
                </div>
            </el-col> -->
        </el-form>
    </div>
</template>
<script>
export default {
    props: ["dialogData"],
    data(){
        return {
            searchData:{
                zsdName:[]
            },//页面数据
            CollegesType:[],//院校类型数据
            zyData:[],//专业名称数据
            kcData:[],//课程数据
            zData:[],//章数据
            jData:[],//节数据
            zsdData:[],//知识点数据
            a:[],
            selectList:[]
        }
    },
      mounted(){
        //   console.log(11111111111,this.dialogData)
        this.init()
    },
    methods:{
        changeZsd(v){
           console.log(11111,v,this.searchData.zsdName)
        },
        init(){
            // 数据回显
            // console.log(this.dialogData.category_name)
            if(this.dialogData && this.dialogData.category_name && this.dialogData.category_name.lore){
                 this.selectList = this.dialogData.category_name.lore
                 this.selectList.map(item=>{
                     this.searchData.zsdName.push(item.node_id)
                 })
            }
            //获取院校类型
            this.$get(this.$api.metaGetorganizationtype).then(res => {
                if(res.code === 0){
                    this.CollegesType = res.ret
                }
            })
        },
        //根据院校类型得到专业数据
        chooseYX(data){
            this.searchData.zyName = ''
            this.searchData.kcName = ''
            this.searchData.zName = ''
            this.searchData.jName = ''
            // this.searchData.zsName = []
            this.kcData=[],//课程数据
            this.zData=[],//章数据
            this.jData=[],//节数据
            this.zsdData=[],//知识点数据
            this.$get(this.$api.categoryGet,{organization_type:data}).then(res => {
                if(res.code === 0){
                    this.zyData = res.ret
                }
            })
        },
        chooseZY(data){
            this.searchData.kcName = ''
            this.searchData.zName = ''
            this.searchData.jName = ''
            // this.searchData.zsdName = []
            this.zData=[],//章数据
            this.jData=[],//节数据
            this.zsdData=[],//知识点数据
            this.$get(this.$api.categoryGet,{category_id:data}).then(res => {
                if(res.code === 0){
                    this.kcData = res.ret
                }
            })
        },
        chooseKC(data){
            this.searchData.zName = ''
            this.searchData.jName = ''
            // this.searchData.zsdName = []
            this.jData=[],//节数据
            this.zsdData=[],//知识点数据
            this.$get(this.$api.categoryGet,{category_id:data}).then(res => {
                if(res.code === 0){
                    this.zData = res.ret
                }
            })
        },
        chooseZ(data){
            this.searchData.jName = ''
            // this.searchData.zsdName = []
            this.zsdData = []
            this.$get(this.$api.categoryGet,{category_id:data}).then(res => {
                if(res.code === 0){
                    this.jData = res.ret
                }
            })
        },
        chooseJ(data){
          if(!data){
            this.zsdData = []
            return
          }
            this.$get(this.$api.categoryGet,{category_id:data}).then(res => {
                if(res.code === 0){
                    this.zsdData = res.ret
                }
            })
        },
        clearData(){
            this.searchData.yxTpye = ''
            this.searchData.zyName = ''
            this.searchData.kcNamec = ''
            this.searchData.zName = ''
            this.searchData.jName = ''
            this.searchData.zsdName = []
            this.zyData=[]//专业数据
            this.kcData=[]//课程数据
            this.zData=[]//章数据
            this.jData=[]//节数据
            this.zsdData=[]//知识点数据
        },

    },


}
</script>
<style scoped>
.chooseZY{overflow:auto; background: #fff;border: 1px solid #d2d1d1; padding: 20px; min-height: 30px; max-height: 200px;}
.button{overflow:hidden; text-align: center; width: 100%;}
</style>
